import React from "react";
import { FormattedMessage } from "react-intl";
import Clear from "material-ui/svg-icons/content/clear";
import { Dialog, FlatButton } from "material-ui";
import { checkMobile } from "../../lib";

function RoleSelect(props) {
  const actions = [
    <FlatButton
      label={<FormattedMessage id="emailAddressBook.host" />}
      primary={true}
      onClick={() => props.handleRoleSelect("host")}
    />,
    <FlatButton
      label={<FormattedMessage id="emailAddressBook.participant" />}
      primary={true}
      onClick={() => props.handleRoleSelect("participant")}
    />,
  ];
  return (
    <Dialog
      actions={actions}
      modal={true}
      open={props.open}
      style={{textAlign: 'center' }}
      actionsContainerStyle={{
        textAlign: "center",
      }}
    >
      <Clear
        onClick={props.closeRoleSelect}
        style={{
          position: "absolute",
          right: checkMobile() ? "5px" : "10px",
          top: checkMobile() ? "5px" : "10px",
          padding: "0",
          cursor: "pointer",
          fill: "#363636",
          width: checkMobile() ? "15px" : "24px",
          height: checkMobile() ? "15px" : "24px",
        }}
      />
      <FormattedMessage id="emailAddressBook.selectRole" />
    </Dialog>
  );
}

export default RoleSelect;



// WEBPACK FOOTER //
// src/components/Seminars/RoleSelect.js